import React, { useEffect, useState } from "react";
import "./styles.css";
import { Setting } from "../../../Utils/Setting";
import {
  Typography,
  Grid,
  CircularProgress,
  TextField,
  Button,
} from "@mui/material";
import { toast } from "react-toastify";
import { getApiData, getAPIProgressData } from "../../../Utils/APIHelper";
import { useSelector } from "react-redux";
import Images from "../../../Config/Images";
import { isMobile, isTablet } from "react-device-detect";

function Contact_Us() {
  useEffect(() => {
    document.title = Setting.page_name.CONTACT;
    getcontectList();
  }, []);

  const { token } = useSelector((state) => state.auth);
  const [data, setData] = useState({});
  const [pageLoader, setPageLoader] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", body: "" });
  const [sending, setSending] = useState(false);

  async function sendMessage(e) {
    e.preventDefault();
    setSending(true);
    try {
      const response = await getAPIProgressData(
        Setting.endpoints.contactUs,
        "POST",
        {
          "ContactForm[name]": form.name,
          "ContactForm[email]": form.email,
          "ContactForm[body]": form.body,
        }
      );
      if (response?.status) {
        toast.success(response?.message);
        setForm({ name: "", email: "", body: "" });
      } else {
        toast.error(response?.message || "Something went wrong");
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
    setSending(false);
  }

  // this function for get contect us data
  async function getcontectList() {
    setPageLoader(true);
    let endpoint = `${Setting.endpoints.cmsdetails}?slug=contact_us`;
    try {
      const response = await getApiData(
        endpoint,
        "GET",
        {},
        { Authorization: `Bearer ${token}` }
      );

      if (response.status) {
        setData(response?.data);
        setPageLoader(false);
      }
    } catch (error) {
      console.log("error ===>>>", error);
      setPageLoader(false);
    }
  }

  return (
    <div>
      <Grid container>
        {pageLoader ? (
          <div
            style={{
              width: "100%",
              display: "flex",
              height: 500,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <Grid
            container
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            minHeight={"80vh"}
            wrap={isMobile ? "wrap" : "nowrap"}
          >
            <Grid
              container={isMobile ? true : false}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <img src={Images.contact} width={isTablet ? "60%" : "90%"} />
            </Grid>
            <Grid
              container={isMobile ? true : false}
              display="flex"
              flexDirection={"column"}
              alignItems="center"
              justifyContent={"center"}
              marginTop={isMobile && 5}
            >
              <Typography className="primarycolor fontsize2">
                Contact Us
              </Typography>
              <div
                dangerouslySetInnerHTML={{
                  __html: data?.app_body || "",
                }}
              />
              <form
                onSubmit={sendMessage}
                style={{ width: "100%", maxWidth: 500, marginTop: 20 }}
              >
                <TextField
                  label="Name"
                  required
                  fullWidth
                  margin="dense"
                  inputProps={{ minLength: 3, maxLength: 30 }}
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                />
                <TextField
                  label="Email"
                  type="email"
                  required
                  fullWidth
                  margin="dense"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                />
                <TextField
                  label="Message"
                  required
                  fullWidth
                  multiline
                  rows={4}
                  margin="dense"
                  value={form.body}
                  onChange={(e) => setForm({ ...form, body: e.target.value })}
                />
                <Button
                  type="submit"
                  variant="contained"
                  disabled={sending}
                  style={{ marginTop: 10, marginBottom: 20 }}
                >
                  {sending ? <CircularProgress size={22} /> : "Send Message"}
                </Button>
              </form>
            </Grid>
          </Grid>
        )}
      </Grid>
    </div>
  );
}

export default Contact_Us;
